import React from 'react'
import { Box, Typography } from '@mui/material'
import { useAlertContext } from '../../contexts/AlertContext'
import AlertHistory from '../AlertHistory'

const HistoryTab: React.FC = () => {
  const { selectedAlert } = useAlertContext()

  if (!selectedAlert) {
    return (
      <Box sx={{ textAlign: 'center' }}>
        <Typography color="text.secondary">No alert selected</Typography>
      </Box>
    )
  }

  return (
    <AlertHistory
      alertId={selectedAlert.id}
      isActive={selectedAlert.active}
      tradingAccountId={selectedAlert.trading?.accountId}
    />
  )
}

export default HistoryTab
